module.exports = __webpack_public_path__ + "static/Relevant-Italic-f73461603fcab5e7af9bcd2b6670d154.woff";